const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  section: {
    padding: '24px',
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    border: '1px solid #E2E8F0',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#1E293B',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px', // Increased gap
  },
  input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      backgroundColor: '#F8FAFC',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: '#F1F5F9',
      },
      '&.Mui-focused': {
        backgroundColor: '#FFFFFF',
      },
    },
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '10px',
    padding: '10px 20px',
    boxShadow: 'none',
  },
  statusBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    borderRadius: '8px',
    backgroundColor: '#F0FDF4',
    border: '1px solid #DCFCE7',
  },
  activeText: {
    fontSize: '12px',
    color: '#15803D',
    fontWeight: 700,
  },
})

export default styles
